module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-10.1ebccf0c.jpg";